// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h5cw","rootNoMargin":"styles_rootNoMargin__2NwPw"};